import React from "react";
import { CompleoListPage } from "customHooks/useList";

const JobList = (props: any) => {
    const module = "JOBLIST";

    return (
        <CompleoListPage
            moduleName={module}
            // mainModuleName={mainModuleName}
            listApiAddress="/job/list"
        />
    );
};

export default JobList;
